const initialState = {
    groupBasicDetails: {},
    groupVisitFindings: {},
    groupGeneralRemarks: {},
    groupRelatedDataSearch: {},
    groupAlert: {},
    groupGrievance: {},
    loadingGroupDetail: false,
    errorsGroupDetail: {}   
};

const groupDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SAVE_GROUP_BASIC_DETAILS_PENDING':
        case 'SAVE_GROUP_VISIT_FINDINGS_PENDING':
        case 'SAVE_GROUP_GENERAL_REMARKS_PENDING':
        case 'SAVE_GROUP_RELATED_DATA_SEARCH_PENDING':
        case 'GROUP_ALERT_PENDING':
        case 'GROUP_GRIEVANCE_PENDING':
            return { ...state, loadingGroupDetail: true };

        case 'SAVE_GROUP_BASIC_DETAILS_FULFILLED':
            return {
                ...state,
                loadingGroupDetail: false,
                groupBasicDetails: action.payload,
                errorsGroupDetail: {}
            };

        case 'SAVE_GROUP_VISIT_FINDINGS_FULFILLED':
            return {
                ...state,
                loadingGroupDetail: false,
                groupVisitFindings: action.payload,
                errorsGroupDetail: {}
            };

        case 'SAVE_GROUP_GENERAL_REMARKS_FULFILLED':
            return {
                ...state,
                loadingGroupDetail: false,
                groupGeneralRemarks: action.payload,
                errorsGroupDetail: {}
            };

        case 'SAVE_GROUP_RELATED_DATA_SEARCH_FULFILLED':
            return {
                ...state,
                loadingGroupDetail: false,
                groupRelatedDataSearch: action.payload,
                errorsGroupDetail: {}
            };

        case 'GROUP_ALERT_FULFILLED':
            return {
                ...state,
                loadingGroupDetail: false,
                groupAlert: action.payload,
                errorsGroupDetail: {}
            };  

        case 'GROUP_GRIEVANCE_FULFILLED':

            return {
                ...state,
                loadingGroupDetail: false,
                groupGrievance: action.payload,
                errorsGroupDetail: {}
            };  
            
        case 'SAVE_GROUP_BASIC_DETAILS_REJECTED':
        case 'SAVE_GROUP_VISIT_FINDINGS_REJECTED':
        case 'SAVE_GROUP_GENERAL_REMARKS_REJECTED':
        case 'SAVE_GROUP_RELATED_DATA_SEARCH_REJECTED':
        case 'GROUP_ALERT_REJECTED':
        case 'GROUP_GRIEVANCE_REJECTED':
            return {
                ...state,
                loadingGroupDetail: false,
                errorsGroupDetail: action.payload
            };

        case 'RESET_GROUP_DETAIL_ERRORS':
            return {
                ...state,
                errorsGroupDetail: {}
            };

        case 'RESET_GROUP_BASIC_DETAILS_DETAILS':
            return {
                ...state,
                groupBasicDetails: {}
            };

        case 'RESET_GROUP_VISIT_FINDINGS_DETAILS':
            return {
                ...state,
                groupVisitFindings: {}
            };

        case 'RESET_GROUP_GENERAL_REMARKS_DETAILS':
            return {
                ...state,
                groupGeneralRemarks: {}
            };

        case 'RESET_GROUP_RELATED_DATA_SEARCH_DETAILS':
            return {
                ...state,
                groupRelatedDataSearch: {}
            };

        case 'RESET_GROUP_ALERT_DETAILS':

            return {
                ...state,
                groupAlert: {}
            };

        case 'RESET_GROUP_GRIEVANCE_DETAILS':

            return {
                ...state,
                groupGrievance: {}
            };

        case 'RESET_CHANGED_GROUP_DETAIL_STATUS_DETAILS':
            return {
                ...state,
                changedGroupDetailStatus: {}
            };

        default:
            return state;
    }
};

export default groupDetailReducer; 